import {  PERSONALINFO_NAME, 
          PERSONALINFO_BIRTHDATE, 
          PERSONALINFO_EMAIL, 
          PERSONALINFO_PHONE, 
          PERSONALINFO_ACCOUNTPASSWORD,
          INCOMEEXPENSES_CREDITCARDS, 
          INCOMEEXPENSES_INCOME,
          INCOMEEXPENSES_LOANS,
          INCOMEEXPENSES_RENT,
          INCOMEEXPENSES_HOUSEHOLDINCOME,
          INCOMEEXPENSES_INVESTMENTINCOME,
          ADDRESS,
          MAILINGADDRESS,
          OCCUPATION,
          AUTHUSER,
          ADDRESS_MOVEINDATE,
          ADDRESS_HOUSINGSTATUS } from './FieldTypes';

import { ResetFieldValidations } from './FormValidator';

export function UpdateFieldsFromSavedState(state, props, type, index) {
  switch(type) {
    case PERSONALINFO_NAME: 
      return {
        ...state,
        personalInfo: {
          ...state.personalInfo, 
          firstName: props.personalInfo.firstName,
          middleName: props.personalInfo.middleName,
          lastName: props.personalInfo.lastName,            
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["firstName", "middleName", "lastName"])}
      };
    case PERSONALINFO_BIRTHDATE: 
      return {
        ...state,
        personalInfo: {
          ...state.personalInfo, 
          birthdate: props.personalInfo.birthdate       
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["birthdate"])}
      };
    case PERSONALINFO_EMAIL: 
      return { 
        ...state,
        personalInfo: {
          ...state.personalInfo, 
          email: props.personalInfo.email        
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["email"])}
      };   
    case PERSONALINFO_PHONE: 
      return {
        ...state,
        personalInfo: {
          ...state.personalInfo, 
          // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
          mobilePhone: props.personalInfo.mobilePhone,
          homePhone: props.personalInfo.homePhone          
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["phone"])}
      };   
    case PERSONALINFO_ACCOUNTPASSWORD:
      return {
        ...state,
        personalInfo: {
          ...state.personalInfo,
          accountPassword: props.personalInfo.accountPassword
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["accountPassword"])}
      }             
    case ADDRESS_MOVEINDATE: 
      return {
        ...state,
        personalInfo: {
          ...state.personalInfo, 
          moveInDate: props.personalInfo.moveInDate      
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["moveInDate"])}
      };    
    case ADDRESS_HOUSINGSTATUS: 
      return {
        ...state,
        personalInfo: {
          ...state.personalInfo, 
          housingStatus: props.personalInfo.housingStatus      
        },
        personalInfoValidation: {...state.personalInfoValidation, ...ResetFieldValidations(["housingStatus"])}
      };           
    case INCOMEEXPENSES_CREDITCARDS:     
      return {
        ...state,
        incomeExpenses: {
          ...state.incomeExpenses, 
          creditcards: props.incomeExpenses.creditcards      
        },
        incomeExpensesValidation: {...state.incomeExpensesValidation, ...ResetFieldValidations(["creditcards"])}
      };
    case INCOMEEXPENSES_INCOME:  
      return {
        ...state,
        incomeExpenses: {
          ...state.incomeExpenses, 
          income: props.incomeExpenses.income      
        },
        incomeExpensesValidation: {...state.incomeExpensesValidation, ...ResetFieldValidations(["income"])}
      };
    case INCOMEEXPENSES_LOANS:  
      return {
        ...state,
        incomeExpenses: {
          ...state.incomeExpenses, 
          loans: props.incomeExpenses.loans      
        },
        incomeExpensesValidation: {...state.incomeExpensesValidation, ...ResetFieldValidations(["loans"])}
      };  
    case INCOMEEXPENSES_RENT:  
      return {
        ...state,
        incomeExpenses: {
          ...state.incomeExpenses, 
          rent: props.incomeExpenses.rent      
        },
        incomeExpensesValidation: {...state.incomeExpensesValidation, ...ResetFieldValidations(["rent"])}
      };
    case INCOMEEXPENSES_HOUSEHOLDINCOME:
      return {
        ...state,
        incomeExpenses: {
          ...state.incomeExpenses,
          householdincome: props.incomeExpenses.householdincome
        },
        incomeExpensesValidation: { ...state.incomeExpensesValidation, ...ResetFieldValidations(["householdincome"]) }
      };
    case INCOMEEXPENSES_INVESTMENTINCOME:
      return {
        ...state,
        incomeExpenses: {
          ...state.incomeExpenses,
          investmentincome: props.incomeExpenses.investmentincome
        },
        incomeExpensesValidation: { ...state.incomeExpensesValidation, ...ResetFieldValidations(["investmentincome"]) }
      };
    case ADDRESS:  
      return {
        ...state,
        address: {
          ...state.address, 
          address1: props.personalInfo.address.address1,      
          address2: props.personalInfo.address.address2,      
          city: props.personalInfo.address.city,      
          province: props.personalInfo.address.province,      
          postalCode: props.personalInfo.address.postalCode,
          manualEntry: true   
        },
        addressValidation: {...state.addressValidation, ...ResetFieldValidations(["address1", "address2", "city", "province", "postalCode"])},
        addressAutocompleteValidation: {
          homeAddress: {
            isInvalid: false,
            message: ""
          }
        }
      };  
    case MAILINGADDRESS:  
      return {
        ...state,
        mailingAddress: {
          ...state.mailingAddress, 
          address1: props.personalInfo.mailingAddress.address1,      
          address2: props.personalInfo.mailingAddress.address2,      
          city: props.personalInfo.mailingAddress.city,      
          province: props.personalInfo.mailingAddress.province,      
          postalCode: props.personalInfo.mailingAddress.postalCode,
          manualEntry: true
        },
        mailingAddressValidation: {...state.mailingAddressValidation, ...ResetFieldValidations(["address1", "address2", "city", "province", "postalCode"])},
        mailingAddressAutocompleteValidation: {
          homeAddress: {
            isInvalid: false,
            message: ""
          }
        }
      };    
    case OCCUPATION:  
      return {
        ...state,
        occupation: {
          ...state.occupation, 
          status: props.occupation.status,      
          industry: props.occupation.industry,      
          occupationName: props.occupation.occupationName,      
          noc: props.occupation.noc,      
          employer: props.occupation.employer,      
          employedSince: props.occupation.employedSince,      
          phone: props.occupation.phone  
        },
        occupationValidation: {...state.mailingAddressValidation, ...ResetFieldValidations(["status", "industry", "occupationName", "employer", "employedSince", "phone"])},
      };   
    case AUTHUSER:  
      return {
        ...state,
        authUsers: 
          [...state.authUsers.slice(0, index),
            {
              id: props.authUsers[index].id,
              firstName: props.authUsers[index].firstName, 
              lastName: props.authUsers[index].lastName, 
              birthdate: props.authUsers[index].birthdate,
              // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
              mobilePhone: props.authUsers[index].mobilePhone,
              homePhone: props.authUsers[index].homePhone,
              // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
              email: props.authUsers[index].email,
              address1: props.authUsers[index].address1, 
              address2: props.authUsers[index].address2, 
              city: props.authUsers[index].city, 
              province: props.authUsers[index].province, 
              postalCode: props.authUsers[index].postalCode,
              sameAsMyAddress: props.authUsers[index].sameAsMyAddress,
              manualEntry: true,
              status: props.authUsers[index].status,
              industry: props.authUsers[index].industry,
              occupationName: props.authUsers[index].occupationName,
              noc: props.authUsers[index].noc
            },
            ...state.authUsers.slice(index + 1, state.authUsers.length)
        ],
        // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
        // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
        authUserValidations:[...state.authUserValidations.slice(0, index), 
          {...state.authUserValidations[index], 
            ...ResetFieldValidations(["firstName", "lastName", "birthdate", "address1", "address2", "city", "province", "postalCode", "mobilePhone", "homePhone", "email", "status","industry","occupationName"])
          },
          ...state.authUserValidations.slice(index + 1)]
      };                                     
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/utils/UpdateFields.js